import clsx from "clsx";
import { PropsWithChildren } from "react";

const BookingCard = ({
  children,
  className,
}: PropsWithChildren<{ className?: string }>) => {
  return (
    <div
      className={clsx(
        "m:p-m bg-neutral-0 rounded-m m:shadow-3 max-w-full",
        className,
      )}
    >
      {children}
    </div>
  );
};

export default BookingCard;
